// 上面 一块的区域
import React, { useEffect, useState } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { isMobile } from "@/utils/common";
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#a8d1f7" : "#cbe4fb",
  // padding: 10,
  border: "1px solid #fff",
  display: "flex",
  minHeight: 177,
  width: "100%",
  flexWrap: "wrap",
  overflow: "hidden",
});

export default function DroppableComUp({ item1, direction, update }) {
  const [draggingIndex, setDraggingIndex] = useState();

  useEffect(() => {
    update && update(Math.random());
  }, [draggingIndex]);

  if (!item1.id) {
    return null;
  }
  const getItemStyle = (
    isDragging,
    draggableStyle,
    draggableleId,
    hasTitle,
    onlyPicture,
    emptyLine = 0
  ) => {
    let styles = { transform: null, transition: null };
    if (draggableleId == sessionStorage.getItem("draggableId")) {
      styles = draggableStyle;
    }
    const h = onlyPicture ? 120 : 146 + emptyLine * 24;
    return {
      ...draggableStyle,
      ...styles,
      userSelect: "none",
      margin: 10,
      display: "inline-block",
      border: isDragging ? "1px solid red" : "1px solid",
      background: isDragging ? "rgb(222, 235, 255)" : "#f5f5f5",
      overflow: "hidden",
      textAlign: isDragging && isMobile ? "center" : "left",
      width: isDragging && isMobile ? 40 : 120,
      height:
        isDragging && isMobile ? 40 :  120,
      minHeight: isDragging && isMobile ? 40 : 120,
    };
  };

  let _childs = [];
  if (direction) {
    _childs = item1.options;
  } else {
    _childs = item1.childs;
  }

  return (
    <Droppable droppableId={item1.id} direction="horizontal">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={getListStyle(snapshot.isDraggingOver)}
          onTouchCancel={() => {

            setDraggingIndex(undefined);
          }}
          onTouchEnd={() => {

            setDraggingIndex(undefined);
          }}
        >
          {(_childs || []).map((item, index) => (
            <Draggable
              key={item.id}
              draggableId={item.codeValue + ""}
              index={index}
            >
              {(provided, snapshot) => {
                const patnTitle = />.+</;
                const hasTitle = patnTitle.test(item.description);
                const patnPic = /^(<p>)?<div class="media-wrap.*(<\/p>)?/;
                const onlyPicture = patnPic.test(item.description);
                const emptyLine = item.description.match(/<p><\/p>/g) || [];
                let html = item.description;
                html = html.replace(/<p><\/p>/g, "<br />");
                html = html.replace(/\n\n/g, "<br />");
                html = html.replace(/\s{2}/g, "&nbsp;&nbsp;");
                html = html.replace(/height="[0-9]+px"/, 'height="100%"');
                html = html.replace(/height:[0-9]+px/, "height:100%");
                html = html.replace(/width="[0-9]+px"/, 'width="100%"');
                html = html.replace(/width:[0-9]+px/, "width:100%");
                return (
                  <div
                    // className="imgdd"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    onTouchStart={() => {
                      setDraggingIndex(index);
                    }}
                    style={{
                      ...getItemStyle(
                        snapshot.isDragging || draggingIndex === index,
                        provided.draggableProps.style,
                        item.codeValue,
                        hasTitle,
                        onlyPicture,
                        emptyLine.length
                      ),
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: html,
                      }}
                    ></div>

                  </div>
                );
              }}
            </Draggable>
          ))}
          {provided.placeholder}
          <style>
            {`
           .imgdd img{
            width:100%

            }`}
          </style>
        </div>
      )}
    </Droppable>
  );
}
